module.exports = __webpack_public_path__ + "shipping-box.dfa1add9e27522acc3ee5d8e061339a9.svg";